module.exports = __webpack_public_path__ + "img/plant_01.6b14270f.jpg";